import { environment } from '../../../../environments/environment';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AgendaService } from '../../../services/agenda-service';
import { Location } from '@angular/common';
import { DialogsService } from '../../../services/dialogs-service';
import { NavigationService } from '../../../services/navigation-service';
import { ENTITY_TYPE_CONSIGNA } from '../../common/activity-list/activity-list.component';
import {
  PATH_COLABORADOR_DETAIL, PATH_CUENTA_DETAIL, PATH_CONTACTO_DETAIL,
  PATH_ACTIVIDAD
} from '../../../navigation/navigation.module';
import { dateToUnixTime, parseDate } from '../../../utils/DateHelper';

@Component({
  selector: 'app-consigna-detail',
  templateUrl: './consigna-detail.component.html',
  styleUrls: ['./consigna-detail.component.scss']
})
export class ConsignaDetailComponent implements OnInit {

  private consignaId: string;
  private consigna: any = {};
  private actividad = [];
  public consignaDescripcion: string;
  private allDay: boolean = false;
  public showOwnerButtons: boolean = false;

  public mainContact;
  public cuentaFullName: string;

  ENTITY_TYPE_CONSIGNA = ENTITY_TYPE_CONSIGNA;
  ASSETS_URL = environment.ASSETS_URL;

  private actividadPage: number = 0;

  constructor(private router: Router,
              private route: ActivatedRoute,
              private agendaService: AgendaService,
              private location: Location,
              private dialogsService: DialogsService,
              private navService: NavigationService) {

  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.consignaId = this.route.snapshot.params['id'];

      this.loadData();
    });
  }

  loadData(){
    this.actividadPage = 0;

    this.getConsigna();
    this.getConsignaActividad();
  }

  getConsigna(){
    this.agendaService.getConsigna(this.consignaId)
          .subscribe( data => {
            this.consigna = data.ResponseData;

            let startDate = parseDate(this.consigna.StartDate);
            let endDate = parseDate(this.consigna.EndDate);

            if(startDate && endDate &&
              startDate.getHours() == 0 && startDate.getMinutes() == 0
              && endDate.getHours() == 23 && endDate.getMinutes() == 59){
              this.allDay = true;
            }

            if(this.consigna.Descripcion){
              this.consignaDescripcion = this.consigna.Descripcion.replace(new RegExp('\n', 'g'), '<br />');
            }
            this.consigna.ConsignaComment.forEach(c => {
              c.CommentForShow = c.Comment.replace(new RegExp('\n', 'g'), '<br />');
            });
            this.showOwnerButtons = Number(localStorage.getItem('userId')) === this.consigna.UsuarioCreadorId;
            this.getCuentasToDisplay();
            console.log(this.consigna);
          });
  }

  getConsignaActividad(){
    this.agendaService.getActividad(this.consignaId, this.actividadPage)
          .subscribe( data => {
            if (this.actividadPage){
              this.actividad = [...this.actividad, ...data.ResponseData];
            } else {
              this.actividad = data.ResponseData;
            }
          });
  }

  getCuentasToDisplay() {
    this.mainContact = null;
    this.cuentaFullName = null;
    if (this.consigna.Cliente) {
      this.cuentaFullName = this.consigna.Cliente.FullName;
      if (this.consigna.Cliente.Contacts && this.consigna.Cliente.Contacts.length) {
        let tmp = this.consigna.Cliente.Contacts.find(c => c.Principal);
        if (tmp) {
          this.mainContact = {Name: tmp.FullName, Id: tmp.ClientContactId};
        } else {
          this.mainContact = {Name: this.consigna.Cliente.Contacts[0].FullName, Id:this.consigna.Cliente.Contacts[0].ClientContactId};
        }
      }
    }
  }

  navigateBack(){
    if (this.navService.isBackBtnReady()) {
      this.location.back();
    } else {
      this.router.navigateByUrl('/' + PATH_ACTIVIDAD + '/agenda');
    }
  }

  onFinishConsigna(){
    this.dialogsService.showRateConsignaDialog()
      .subscribe( res => {
          if (res){
            this.agendaService.rateConsigna(this.consigna.Id, res)
              .subscribe( data => {
                this.loadData();
              });
          }
      });
  }

  onReactivateConsigna(event){
    this.dialogsService.confirm(null,
              "¿Está seguro de que desea reactivar esta consigna?",
              "SÍ, REACTIVAR",
              "NO, CANCELAR")
    .subscribe( res => {
      if (res){
        this.agendaService.reactivateConsigna(this.consigna.Id)
          .subscribe( data => {
            this.loadData();
          });
      }});
  }

  onDeleteConsigna(){
    this.dialogsService.confirm(null,
                "¿Está seguro de que desea eliminar esta consigna?",
                "SÍ, ELIMINAR",
                "NO, CANCELAR")
      .subscribe( res => {
        if (res){
          this.agendaService.deleteConsigna(this.consigna.Id)
            .subscribe( data => {
              this.navigateBack();
            });
        }});
  }

  onEditConsigna(){
    this.dialogsService.showEditConsignaDialog(this.consigna)
    .subscribe( () => {
      this.loadData();
    });
  }

  isCurrentUserComment(message){
    return message.Usuario.UserId == localStorage.getItem('userId');
  }

  onEditComment(message){
    this.dialogsService.showTextAreaDialog('Editar comentario', message.Comment, 'ACEPTAR', 'CANCELAR')
    .subscribe(value => {

      if (!value){
        return;
      }

      this.agendaService.editComment(message.Id, value)
        .subscribe( data => {
          this.loadData();
        });
    });
  }

  onDeleteComment(message){
    this.dialogsService.confirm(null,
      "¿Está seguro de que desea eliminar este comentario?",
      "SÍ, ELIMINAR",
      "NO, CANCELAR")
        .subscribe( res => {
        if (res){
          this.agendaService.deleteComment(message.Id)
            .subscribe( data => {
              this.loadData();
            });
        }});
  }

  showAddCommentDialog(){
    this.dialogsService.showTextAreaDialog('Escribe un comentario', null, 'ACEPTAR', 'CANCELAR')
      .subscribe(value => {

        if (!value){
          return;
        }

        this.agendaService.addConsignaComment(this.consignaId, value)
          .subscribe( data => {
            this.loadData();
          });
      });
  }

  onColaboradorSelected(colaborador){
    this.router.navigate([PATH_COLABORADOR_DETAIL, colaborador.UserId]);
  }

  onCuentaSelected(cuenta){
    this.router.navigate([PATH_CUENTA_DETAIL, cuenta.Id])
  }

  onContactoSelected(contacto){
    this.router.navigate([PATH_CONTACTO_DETAIL, contacto.Id])
  }

  onBottomReached(reached: boolean) {
    this.actividadPage++;
    this.getConsignaActividad();
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/agenda/consigna-detail/consigna-detail.component.ts